export default [ 
  {
    name: "Flex Container",
    properties: [
      {
        name: "Direction",
        value: "flex-direction",
        type: "text",
        shorthand: "flex-flow",
        autocomplete: ["row", "row-reverse", 'column', 'column-reverse'],
      },
      {
        name: "Wrap",
        value: "flex-wrap",
        type: "text",
        shorthand: "flex-flow",
        autocomplete: ["wrap", "nowrap", 'wrap-reverse'],
      },
      {
        name: "Flow",
        value: "flex-flow",
        type: "text",
      },
      {
        name: "Justify Content",
        value: "justify-content",
        type: "text",
        autocomplete: ["flex-start", "flex-end", 'center', 'space-between', 'space-around', 'space-evenly', 'start', 'end', 'left', 'right', 'safe', 'unsafe'],
      },
      {
        name: "Align Items",
        value: "align-items",
        type: "text",
        autocomplete: ["flex-start", "flex-end", 'stretch', 'center', 'baseline', 'first baseline', 'last baseline', 'start', 'end', 'self-start', 'self-end', 'safe', 'unsafe'],
      },
      {
        name: "Align Content",
        value: "align-content",
        type: "text",
        autocomplete: ["flex-start", "flex-end", 'center', 'space-between', 'space-around', 'space-evenly', 'start', 'end', 'stretch', 'baseline', 'first baseline', 'last baseline', 'safe', 'unsafe'],
      },
    ]
  },
  {
    name: 'Flex Items',
    properties: [
      {
        name: "Order",
        value: "order",
        type: "number",
      },
      {
        name: "Grow",
        value: "flex-grow",
        type: "number",
        shorthand: "flex",
      },
      {
        name: "Shrink",
        value: "flex-shrink",
        type: "number",
        shorthand: "flex",
      },
      {
        name: "Basis",
        value: "flex-basis",
        type: "text",
        shorthand: "flex",
      },
      {
        name: "Flex",
        value: "flex",
        type: "text",
      },
      {
        name: "Align",
        value: "align-self",
        type: "text",
        autocomplete: ['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
      },
    ]
  }
]